const BaseModel = require('lib/base_model')
const ElementTypes = require('./element_types')

// Element model constructor, wraps other ElementTypes
const Element = BaseModel.extend({

     
    constructor: function constructor(attrs = {}, options) {
        const ElementType = ElementTypes[attrs.type]

        if (! ElementType) throw new Error('Element requires a valid type.')

        return new ElementType(attrs, options)
    },

})

module.exports = Element
